/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";

export type AlertType = "info" | "success" | "failure" | "warning";

export interface IAlert {
    title: string
    show: boolean
    type: AlertType
}

interface IAlertContext{
    alert: IAlert
    open: (ttl: string, tp: AlertType) => void
    close: () => void
}
export const AlertContext = createContext<IAlertContext>({
    alert: {title: '', show: false, type: 'info'},
    open: () => {},
    close: () => {},
})


export const useAlert = () => useContext(AlertContext)